import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { ModalComponent } from '../components/modal/modal.component';
import { ModalConfiguration } from '../models/modal.model';

@Injectable()
export class ModalService {
    constructor(public dialog: MatDialog) {}

    openModal(configuration: ModalConfiguration, sizeConfiguration?: MatDialogConfig): void {
        this.dialog
            .open(ModalComponent, {
                data: configuration,
                panelClass: 'app-modal-container',
                minWidth: 340,
                ...sizeConfiguration,
            })
            .afterClosed()
            .pipe(take(1))
            .subscribe((data) => {
                configuration.callbackFn(data);
            });
    }
}
